import React from 'react';
import * as styles from '../../Controls.module.scss';
import { Text } from '@input';
import { keys } from '@enums';
import { isPurchase, isRefinance } from '@helpers';
import { isString } from 'lodash';
import classNames from 'classnames';

function CashOutAmount({ loanAmount, loanPurpose, ...props }) {
  return isPurchase(loanPurpose) ? null : (
    <div className={classNames('cash-out-wrapper', styles.cashOutWrapper)}>
      <Text
        label={
          <>
            Cash Out <span className={styles.optional}>(Optional)</span>
          </>
        }
        placeholder="Enter a cash out amount"
        className="input-cash-out"
        fieldClassName="field-cash-out"
        name={keys.CASH_OUT_AMOUNT}
        maxWidth={350}
        isCurrency
        {...props}
      />
    </div>
  );
}

function validate(num, state) {
  if (!isRefinance(state.loanPurpose)) {
    return null;
  }

  if (isString(num)) {
    num = num.trim();

    if (!num) {
      return null;
    }
  }

  const value = parseFloat(num);

  if (num && isNaN(value)) {
    return 'Enter a valid cash out amount';
  }

  if (value < 0) {
    return 'Cash out amount cannot be negative';
  }

  const loanAmount = parseFloat(state.loanAmount);
  const homeValue = parseFloat(state.homeValue);

  if (
    !isNaN(loanAmount) &&
    !isNaN(homeValue) &&
    !isNaN(value) &&
    value + loanAmount >= homeValue
  ) {
    return 'Cash out amount plus loan amount must be less than home value';
  }
}

export default {
  Component: CashOutAmount,
  dependencies: keys.LOAN_PURPOSE,
  validate: {
    fn: validate,
    dependencies: [keys.LOAN_AMOUNT, keys.HOME_VALUE]
  }
};
